module.exports = __webpack_public_path__ + "img/thumbnail-project-default.04839408.svg";